import { render, staticRenderFns } from "./RowActions.vue?vue&type=template&id=8545058a&scoped=true&"
import script from "./RowActions.vue?vue&type=script&lang=js&"
export * from "./RowActions.vue?vue&type=script&lang=js&"
import style0 from "./RowActions.vue?vue&type=style&index=0&id=8545058a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545058a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
